export default __webpack_public_path__ + "static/media/LakshmiSubramanian.6b9dfdf8.png";